<style lang="scss" scoped>
.group {
    @apply bg-light hover:bg-green text-dark hover:text-white;

    &.active {
        @apply bg-green;
        .title {
            @apply text-white;
        }
        ::v-deep svg {
            fill: white !important;
        }
    }
    &:not(.active) {
        .title {
            @apply group-hover:text-white;
        }
    }
}
</style>

<template>
    <div class="group flex items-center p-16 mb-24 transition-colors cursor-pointer" :class="{ active: active }" @click="showFavorites">
        <span class="title flex-1">Mijn favorieten</span>
        <span v-html="svg('heart', 'w-16 h-16 stroke-green fill-transparent group-hover:fill-white group-hover:stroke-white transition-colors')"></span>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: false,
        };
    },
    methods: {
        showFavorites() {
            let favorites = JSON.parse(localStorage.getItem("s2w-favorites") || "[]") || [];

            if (this.active) {
                window.history.pushState({}, document.title, window.location.pathname);
                favorites = [];
                this.active = false;
            } else {
                window.history.pushState({}, document.title, `${window.location.pathname}?favorites`);
                this.active = true;
            }

            this.$emit("click", favorites);
        },
    },
};
</script>
